import React from "react";
import ReportIcon from "Assets/images/alert-new-icon.svg";
import useStyles from "./styles";

const ErrorValidation = ({ error }) => {
  const classes = useStyles();
  return (
    <span className={`${classes.errorMessages} error-msg`}>
      <img src={ReportIcon} alt="report icon" />
      {error}
    </span>
  );
};

export default ErrorValidation;
